export default {
  signal: 'Signal',
  unit: 'Unit',
  min: 'Min',
  max: 'Max',
  average: 'ȳ',
  standardDeviation: 'σ',
  cursor: 'cursor',
};
